export default {
  release: '17.3',
  date: 'August 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-3-released/#this-months-notable-contributor-anton-kalmykov',
  contributors: [
    {
      name: 'Anton Kalmykov',
      gitlabUsername: 'antonkalmykov',
    },
  ],
  writeUp: `Anton Kalmykov is one of GitLab's top contributors this year with 37 [merged contributions](https://gitlab.com/gitlab-org/gitlab/-/merge_requests?scope=all&state=merged&author_username=antonkalmykov)
since February and more in progress.
Anton is a Senior Frontend Engineer at [Yolo group (Bombay Games)](https://yolo.com/).

"Contributing to GitLab is one of the most challenging, ambitious, and exciting initiatives," says Anton.
"I appreciate the opportunity to be involved in creating and improving such a great product.
Thanks to this chance, I have learned a lot of new things, and I still have a lot to do.
I am incredibly grateful to the GitLab team, especially those who have checked my MRs, guided me,
and helped me do things right."

Anton was nominated by [Christina Lohr](https://gitlab.com/lohrc), Senior Product Manager at GitLab,
for helping out the Tenant Scale
group with several frontend issues.

"We have a lot of smaller UX improvements to work through for our basic workflows, and it is great
to get help from the community to complete these initiatives faster," says Christina.
"All these improvements are helping to create a more cohesive user experience between groups and projects.
Thank you Anton."

Many thanks to Anton and the rest of GitLab's open source contributors for co-creating GitLab!`,
};
